<template>
  <div class="faq">
    <Modal
      v-model="modalAdd"
      title="新增商品"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
        <p>搭配屋套装列表：</p>
        <Select v-model="addContentSuitId" filterable>
          <Option v-for="item in filterSuitContentList" :value="item.id" :key="item.id">{{ item.title }}</Option>
        </Select>
        <div v-if="addContentSuitCheck!=''"><span>套装状态：</span><span style="color: red;">{{addContentSuitCheck}}</span></div>
        <p>图片-商店-shop：{{shop_image_name}}</p>
        <Upload action="" :before-upload="addImageForShop" :multiple="false">
            <Button icon="ios-cloud-upload-outline">上传图片</Button>
        </Upload>
        <div>
            <span style=" width: 240px; margin-right: 35%;">搭配屋预览图</span>
            <span style=" width: 240px;">套装预览图</span>
        </div>
        <div>
            <img class="suit_back" :src="addContentSuitPreview" @error="imgPlaceholder" style="width: 45%;margin-right: 5%;">
            <img :src="addContentSuitShopPreview" style="background-color: #f1e4b7; width: 45%;height:45%">
        </div>
        <p>备注：默认直接为上架状态</p>
    </Modal>
    <div class="headers">
      <Button @click="toBuildSuitCoInit" style="float: left;">生成推荐套装(正式小Co账号)</Button>
      <!-- <span style="float: left; margin-top: 1rem;"</span> -->
      <span>店铺：</span>
      <Select @on-change="changeSelect" v-model="selectShopId" style="width: 9rem">
        <Option
          v-for="item in filterShopList"
          :value="item.id"
          :key="item.id"
        >{{ item.title }}</Option>
      </Select>
      <span style="margin-left: 10px">性别：</span>
      <Select @on-change="changeSelect" v-model="sex" style="width: 80px">
        <Option
                v-for="item in filterSex"
                :value="item.value"
                :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <Button @click="toShowAddSuit">新增</Button>
      <Button @click="getRecords">刷新</Button>
    </div>
    <Table :columns="columns" :data="data">
		<template slot-scope="{ row, index }" slot="id">
		  <span>{{ row.id }}</span>
		</template>
		
		<template slot-scope="{ row, index }" slot="shop_url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.shop_url"  style="background-color: #f1e4b7;">
		        </div>
		        <img :src="row.shop_url" style="background-color: #f1e4b7; width: 60px;height: 60px;">
		    </Poptip>
		</template>
        <template slot-scope="{ row, index }" slot="suit_url">
            <Poptip trigger="hover" :transfer="true" title="图片详情">
                <div class="info-pop" slot="content">
                    <img class="suit_list" :src="row.suit_url">
                </div>
                <img class="suit_list" :src="row.suit_url" style="width: 60px;height: 60px;">
            </Poptip>
        </template>
      <template slot-scope="{ row, index }" slot="content">
        <span>{{ row.content }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="sex">
        <template v-if="editIndex === index">
          <Select v-model="updateSex" filterable>
            <Option v-for="item in filterSex.slice(0,2)" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.sex|getSex }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable>
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>
      <template slot-scope="{ row, index }" slot="action">
          <div v-if="editIndex === index">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button
              style="margin-left: 10px"
              @click="editIndex = -1"
              :disabled="action_btn_disabled"
            >取消</Button>
          </div>
          <div v-else>
            <Button @click="toSoldOut(row, index)" style="margin-right: 10px;">下架</Button>
			<Button @click="handleToTop(row, index)">置顶</Button>
          </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
      addRecordRunning:false,
	  ossClient: null,
	  shop_image_name: null,
	  shop_image_data: null,
	  
      filterStatus: [{ label: '正常', value: 0 }, { label: '下架', value: -1 }, { label: '赠品', value: -2 }],
      filterShopList: [{id:0,title:"全部"}],
      filterSuitContentList:[],
      addContentSuitId: 0,
      addContentSuitPreview: "",
      addContentSuitShopPreview: "",
      addContentSuitTempFileName:"",
      addContentSuit:null,
      addContentSuitCheck:"",
      selectShopId: 0,
      classify: 1,
      filterSex: [{ label: '女', value: 0 }, { label: '男', value: 1 }, { label: '全部', value: -1 }],
      sex: 0,   // 0女，1男，-1全部
      data: [],
      tmpData: [],
      modalAdd: false,
      action_btn_disabled: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,
      sortBtnDesc: "排序",
      updateImages: "",
      updateSex: 0,
      updateDiscount: 0,
      updateJewelPrice: null,
      updateCoinPrice: null,
      updateStatus: 0,
      columns: [
		  {
		    title: 'ID',
		    slot: 'id',
		    width: 80
		  },
		  {
		    title: '商店缩略图',
		    slot: 'shop_url',
		    width: 0
		  },
          
          {
            title: '搭配屋缩略图',
            slot: 'suit_url',
            width: 0
          },
    
        {
          title: '子商品ID',
          slot: 'content',
          // width: 120
        },
        {
          title: '性别',
          slot: 'sex',
          width: 80
        },
        {
          title: '状态',
          slot: 'status',
          width: 80
        },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '操作',
          slot: 'action',
          width: 180
        }
      ]
    }
  },
  async created() {
	this.getOss();
    await this.getOptions()
    await this.getRecords()
    
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function (newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },
    modalAdd: function (newVal, oldVal) {
      if (newVal) {
         this.addRecordRunning = false
         this.addContentSuitId = 0
         this.addContentSuitPreview = ""
         this.addContentSuitShopPreview = ""
         this.addContentSuitTempFileName = ""
         this.addContentSuit = null
         this.shop_image_name =""
         this.shop_image_data =""
         this.addContentSuitCheck = ""
      }
    },
    addContentSuitId: function (newVal, oldVal) {
        console.log(newVal)
        if (newVal && newVal>0) {
            this.filterSuitContentList.forEach(item => {
                if(item.id == newVal){
                    let content = item.content
                    let name = content.replaceAll(",","_")+".png"
                    this.addContentSuitPreview = "https://image.co-study.com.cn/app/image/figure/suit/"+name
                    this.addContentSuitTempFileName = name
                    this.addContentSuit = item
                    this.addRecordRunning = false
                    this.shop_image_name = ""
                    this.shop_image_data = ""
                    this.addContentSuitShopPreview = ""
                    this.addContentSuitCheck = ""
                    this.checkSuit()
                }
            })
          
        }
    },
  },
  methods: {
    imgPlaceholder(e) {
        e.target.src = require('@/assets/suit_stand_bg.png')
    },
	async getOss() {
	    apis.get_oss().then(res => {
	        this.ossClient = new OSS({
	            region: 'oss-cn-shanghai',
	            accessKeyId: res.AccessKeyId,
	            accessKeySecret: res.AccessKeySecret,
	            stsToken: res.SecurityToken,
	            bucket: 'co-study',
	        })
	    }).catch(err => {
	        console.log(err)
	    })
	},
	async addImageForShop(event) {
		return this.addImgRecord(event, 1)
	},
	async addImgRecord(event, type) {
	    try {
	        let ts = (new Date()).valueOf();
	        let filename = '.' + event.name.split('.').pop();
	        if(filename !== '.png'){
	            this.$Message.error('仅支持上传png格式的图片');
                this.addContentSuitTempFileName = ""
                this.shop_image_name = ""
                this.shop_image_data = ""
	            return Promise.reject()
	        }
            // 加载本地预览图
            let _this = this
            let img = new Image() 
            if (!event || !window.FileReader) return  // 判断是否支持FileReader
            await new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.readAsDataURL(event) // 文件转换
                reader.onloadend = function () {
                    _this.addContentSuitShopPreview = this.result
                    img.src = this.result
                    img.onload = () => {
                        resolve({
                            width: img.width,
                            height: img.height
                        })
                    }
                }
            })
           if(img.width  !=540 || img.height != 540 ){
               this.$Message.error('商店预览图的大小为540x540px');
               this.addContentSuitTempFileName = ""
               this.shop_image_name = ""
               this.shop_image_data = ""
               return Promise.reject()
           }
            
			if (type === 1){
				this.shop_image_name = this.addContentSuitTempFileName
				this.shop_image_data = event
			}
           
	    } catch (e) {
	        console.log(e);
	        this.$Message.error('上传至oss失败');
            this.addContentSuitTempFileName = ""
            this.shop_image_name = ""
            this.shop_image_data = ""
	    }
	    return Promise.reject()
	},
	async upload_image_to_oss(){
		let oss_url = 'app/image/figure/suit/shop/'
		let result = await this.ossClient.put(oss_url + this.shop_image_name, this.shop_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		return true
	},
    async getRecords() {
      let params = {
        'shop_id': this.selectShopId,
        'sex': this.sex,
      }
      apis.suit_shop_all_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
    async getOptions() {
      apis.image_shop_records().then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
            
          this.filterShopList = data.records;
          let all = {id:0,title:"全部"}
          this.filterShopList.unshift(all)
        }
      }).catch()
    },
    getSuitShopUserContent() {
      let params = {
        shop_id: this.selectShopId,
        sex: this.sex
      }
      apis.suit_shop_user_content(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.filterSuitContentList = data.suits;
        } else {
          alert(msg)
        }
      }).catch()
    },
    async addRecord() {
      if(this.addContentSuitCheck!=''){
          this.$Message.error('该套装已经存在或有非当前店铺的商品！');
          return 
      }
	  if (!this.shop_image_name) {
	    this.$Message.error('图片不能为空');
	    return
	  }
	  let upload_result = await this.upload_image_to_oss()
	  if (!upload_result) {
		  this.$Message.error('图片上传失败');
		  return
	  }else{
		  this.$Message.success('图片上传成功');
	  }
      let post_data = {
        user_suit_id: this.addContentSuitId,
        shop_id: this.selectShopId
      }
      if(this.addRecordRunning === true){
         this.$Message.error('操作太频繁啦！');
         return
      }
      this.addRecordRunning = true
	  console.log(post_data)
      await apis.suit_shop_create(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.shop_image_name = null
          this.shop_image_data = null
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        this.$Message.error(res.toString());
      })

      await this.getRecords()
    },
    checkSuit(){
        let params = {
            user_suit_id: this.addContentSuitId,
            shop_id: this.selectShopId
        }
        apis.suit_shop_check(params).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
              this.addContentSuitCheck = ""
          } else {
            this.addContentSuitCheck = msg
            this.$Message.error(msg);
          }
        }).catch(res =>{
            this.addContentSuitCheck = res.toString()
            this.$Message.error(res.toString());
        })
    },
	figureImageSortToTop(index) {
	 
	  let post_data = {
	    suit_id: this.data[index].id,
	  }
	  apis.suit_shop_sort_top(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
    toShowAddSuit() {
        if(this.selectShopId === 0){
          this.$Message.warning('全部下不可新增套装');
          return
        }
        this.modalAdd = true
        this.getSuitShopUserContent()
    },
    toBuildSuitCoInit() {
       let params = {
       }
       apis.suit_shop_recommend_clothes_init(params).then(res => {
         const { data, errCode, msg } = res;
         if (errCode === 0) {
            this.$Message.success('操作成功');
         } else {
           alert(msg)
         }
       }).catch()
    },
    async changeSelect() {
      await this.getRecords()
    },
	handleToTop(row, index) {
	  this.figureImageSortToTop(index);
	},
    toSoldOut(row, index) {
        var isNext = confirm("是否下架套装，下架后将无法再上架？")
        if(isNext){
            // status -1 为下架
            let post_data = {
                suit_id: this.data[index].id,
                status: "-1"
            }
            apis.suit_shop_update_record(post_data).then(res => {
            const { data, errCode, msg } = res;
            if (errCode !== 0){
                this.$Message.error(msg);
            }
            this.getRecords()
            })
        }
    },
  },
  computed: {
    
  },
  filters:{
    getSex(val){
      if(val === 0) {
        return '女'
      }else {
        return '男'
      }
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

.suit_list {
    background-image: url(../../assets/suit_stand_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
}

.suit_back {
    width: 45%;
    height 100%;
    background-image: url(../../assets/suit_stand_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
}

</style>